export default {
  language: 'en',
  defaultPageTitle: 'DPDK',
  pageTitleSuffix: 'Exceptional Digitalism',
  PUBLIC_RECAPTCHA_SITE_KEY: '6LfHpKUeAAAAAFtKAP0wIsWn40TngQrq_smM9r8z',
};
